import React, { useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Container, Col, Row, Button, Form } from 'react-bootstrap';
import { SERVER } from '../../constants/networkUrls';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { isRestrictEmail,isValidEmailInput } from './emailRestriction';
//css files
import './email.css'
//comman components
import Header from "../../layouts/header"
import Loader from '../../layouts/loader/index';
import EmailModal from '../../layouts/modal/emailModal';
import EmailInfoModal from '../../layouts/modal/emailInfoModal';
import PolicyModal from '../../layouts/modal/policyModal';
import Labels from '../../components/translations/translation.json'
import {languageCodeMapper} from '../space/translationCodeMapper';
import EmailWarningModal from '../../layouts/modal/emailWarningModal';
import ButtonMailto from './buttonEmail';
import Footer from '../../layouts/footer/footer';
import configuration from '../../configuration.json';
import apiConfig from '../trustBuilder/Auth/services/apiConfig';
import ValidationUI from '../space/validationUi';

function EmailComponent(props) {

    const [update, setUpdate] = useState(false);
    const [newEmailId, setNewEmailId] = useState("");
    const [emailHash,setEmailHash] = useState("");
    const [emailModalState, setEmailModalState] = useState(false);
    const [emailValidateErr, setEmailValidateErr] = useState(false);
    const [policyModalState, setPolicyModalState] = useState(false);
    const [emailUpdateTextState, setEmailUpdateTextState] = useState(false);
    const [emailDeleteTextState, setEmailDeleteTextState] = useState(false);
    const [emailInfoModalState, setEmailInfoModalState] = useState(false);
    const [infoModalType,setInfoModalType] = useState(true);
    const [isEmailValid,setIsEmailValid] = useState(null);
    const [isDeleteEmail,setIsDeleteEmail] = useState(false);
    const [isEmailUpdated,setIsEmailUpdated] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [presentEmailInvalidModal,setPresentEmailInvalidModal] = useState(false)
    const navigate = useNavigate();

    const hostname = window && window.location && window.location.hostname;
	const environmentConstants = apiConfig.setEnvironmentURLs(hostname);
   
    const trustBuilder = false;

	

    let hashCode = props.hashCode;
    let isFMO = props.isFMO;
    console.log("props of FMO",isFMO);
    const decodedString = atob(hashCode);
    const removeLetter = decodedString.replace("%","");
    const splitString = removeLetter.split("$");
    console.log("splitString",splitString[0],splitString[1],splitString[2]);
	const [langCode, setlangCode] = useState(splitString[0]);
    const requestorId = splitString[1];
    const requestorEmailId = splitString[2].replace("%","");
    console.log("requestorEmailId",requestorEmailId);
    
    console.log("LangCode",langCode);

    const handlePopulateEmailUpdateInput = () => {
        setUpdate(true);
    }

    const handleEmailNotVailableClose = () => {
        setPresentEmailInvalidModal(false)

    }

    useEffect(() => {
        setIsLoading(true);
		handleCheckEmail();
	},[]);

    const isValidEmail = (email) => {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    }
   

    const handleChangeEmail = (e) => {
        setNewEmailId(e.target.value);
        if (newEmailId !== "") {
            setEmailValidateErr(false);
        }


        if(!isValidEmailInput(e.target.value)) {
			setEmailValidateErr(Labels[langCode].EMAIL_VALIDATION_ERROR);
		} else {
			if(isRestrictEmail(e.target.value)) {
				setEmailValidateErr(Labels[langCode].EMAIL_OPTOUT_VALIDATION_ERROR);
			} else {
				setEmailValidateErr(null);
			}
		}

        console.log("new Email Id",newEmailId);
    }

    const checkEmailValidationError = (languageCode) => {

        if ((newEmailId === "") || (!isValidEmail(newEmailId))) {
            setEmailValidateErr(Labels[languageCode].EMAIL_VALIDATION_ERROR);
        } else {
            setEmailValidateErr(null);
        }

        if ((newEmailId === "") || (!isValidEmail(newEmailId))) {
            return false
        }

        return true; 
    }

    const handledropdown = (e) => {
		setlangCode(e.target.value)
        if(emailValidateErr){
			checkEmailValidationError(e.target.value)
		}
	}

    const handleEmailUpdate = () => {
        const emailIdUpdate = newEmailId ? newEmailId : emailHash

        if(isRestrictEmail(newEmailId)){
            return;
        }

        if(checkEmailValidationError(langCode)) {
       
            setEmailValidateErr(null);
            setNewEmailId(emailIdUpdate);
            setEmailModalState(true);
            setEmailUpdateTextState(true);
            setEmailDeleteTextState(false);
        }

        if(newEmailId.length == 0){
            return;
        }
    }

    const handleEmailDelete = () => {
        setEmailModalState(true)
        setEmailDeleteTextState(true);
        setEmailUpdateTextState(false);
    }

    const handleCancelEmailUpdateInput = () => {
        setUpdate(false);
        setNewEmailId(emailHash);
        setEmailValidateErr(null)
    }

    const handleClose = () => {
        setEmailModalState(false);
    }

    const handlePolicyModal = () => {
		setPolicyModalState(true);
	}
	
	const handlePolicyClose = () => {
		setPolicyModalState(false);
	}

    const handleInfoClose = () => {
       setEmailInfoModalState(false);
       // Go to the Error Page if it is Delete Modal. 
       
    }

    

    const handleCheckEmail = () => {        
        let authConfig = {
                headers:{
                    "X-API-KEY" : environmentConstants.apiKey
                }
            }
        
       
        const apiUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.updateEmail}${requestorEmailId}`;
        console.log("apiURL",apiUrl); 
        axios.get(apiUrl,authConfig).then(response => { 
            console.log("response",response)
            setIsLoading(false);

            if (response.data.available !== "false") {
                console.log("this email id is available");
                setIsEmailValid(true);
                setEmailHash(requestorEmailId);
                
            } else {
                console.log("Sorry this email id is not available");
                setIsEmailValid(false);
                setPresentEmailInvalidModal(true);
            }
        }).catch(error => {
            setIsLoading(false);
            setIsEmailValid(false);
            setPresentEmailInvalidModal(true);

		console.log("error",error);
		})
    
    }


    const handleUpdateEmail = () => {
       
        let authConfig = {
                headers:{
                    "X-API-KEY" : environmentConstants.apiKey
                }
            }
        
        const apiUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.updateEmail}${requestorId}`;
        console.log("apiURL",apiUrl); 
        console.log("new email id",newEmailId)
        const emailIdUpdate = newEmailId ? newEmailId : emailHash
            const updatedEmailData = {
                "requestorId": requestorId,
                "fromEmailId": requestorEmailId,
                "emailId": emailIdUpdate
              }
            axios.put(apiUrl, updatedEmailData,authConfig).then((response) =>{
                console.log("response of UpdatedEmail Response only",response);
                console.log("response of response.status",response.status);
                if(response.status === 200) {
                    setInfoModalType(true);
                    setEmailInfoModalState(true);
                    setEmailHash(newEmailId)
                    setIsEmailUpdated(true);
                    setIsEmailValid(false);
                  } else {
                      console.log("Error while updating");
                  }
                setEmailModalState(false);
            }).catch(error => {
                setEmailModalState(false);
                setIsEmailUpdated(false);
              console.log("error",error); 
            })
        
        setUpdate(false);
      }
      const handleDeleteEmail = () => {
        
        let authConfig = {
                headers:{
                    "X-API-KEY" : environmentConstants.apiKey
                }
            }
        
        const apiUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.updateEmail}${requestorId}`;
            console.log("apiURL",apiUrl); 
                
                const deleteEmailData = {
                  "requestorId": requestorId,
                  "fromEmailId": "",
                  "emailId": emailHash
                }

                console.log("API URL",apiUrl)
                console.log("params",deleteEmailData)
                console.log("authConfig",authConfig)


                axios.delete(apiUrl,{ data:deleteEmailData},authConfig).then((response) => {
                    console.log("response of UpdatedEmail",JSON.stringify(response.data));
                    console.log("response of UpdatedEmail Response only",response);
                    console.log("response of response.status",response.status);
                    if(response.status === 200) {
                        setInfoModalType(false);
                        console.log("langCode in delete API",langCode);
                        setIsEmailValid(false)
                        setIsDeleteEmail(true);
                        setEmailInfoModalState(true);
                           
                      } else {
                          console.log("Error while deleting");
                      }
                    setEmailModalState(false);
                    }).catch(error => {
                    setEmailModalState(false);
                   console.log("error",error); 
                })
      }


return(
     <>
        {isEmailValid && <Header
                langCode={langCode}
                isPrivate={isFMO}
                handledropdown={handledropdown} />}

        {! isEmailValid && !isLoading && 
        <div>
            <Header 
        langCode={langCode}
        isPrivate={isFMO}
        handledropdown={handledropdown}
             />
             <Container fluid style={{height : '100%', backgroundColor : '#F0F5FA'}} className='container-email-main'>
             <Row>
             <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
                 <div>
                 </div>
             </Col>
             <Col xl={6} lg={6} md={8} sm={10} xs={12} xxs={12} className="subContainer-emailDeletedPage">
             <Container fluid className='container-title-deletePage'>
                        <Row className="row">
                            <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12} className="col-text">
                                {isEmailUpdated ?  <span style={{fontSize: '17px',fontWeight : '400',margin : '20px'}} className='emailText_DeletePage'>
                        {Labels[langCode].EMAIL_UPDATED_MODAL}
                        {Labels[langCode].RESEND_EMAIL_PARA1} 6 {Labels[langCode].RESEND_EMAIL_PARA2}
                         </span> :  <span className='emailText-title-deletepage'>{Labels[langCode].EMAIL_OPTOUT}</span>}
                            </Col>
                        </Row>
                </Container>
                <Container fluid className='container-deletepage-text-first-email'>
                    <Row className="row">
                        <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                        <span style={{fontSize: '17px',fontWeight : '400',margin : '20px'}} className='emailText_DeletePage'>
                            {!isEmailUpdated && !isEmailValid && Labels[langCode].EMAIL_DELETED_PAGE}
                         </span>
                        </Col>
                        {
                            emailInfoModalState && !isEmailUpdated  ? 
                            <EmailInfoModal updateModal={false} langProp={langCode} callbackClose={handleInfoClose}/>
                             : ""
                        }
                    </Row>
                </Container>
                </Col>
                <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
                    <div>
                    </div>
                </Col>
                </Row>
                <Container className='empty-space-deleteEmailPage'>
                    <div></div>
                </Container>
                </Container>
                </div>
}
        {isEmailValid ?   
        <Container fluid  className='container-email-main'>
        <Row>
        <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
            <div>
            </div>
        </Col>
        <Col xl={6} lg={6} md={8} sm={10} xs={12} xxs={12} className="subMain-container-emailPage">
                <Container fluid className='container-title'>
                    <Row className="row">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                            <div className="emailPage-firstPara-div">
                                <span className='emailText-title'>{Labels[langCode].EMAIL_OPTOUT}</span>
                            </div>  
                            <div className="emailPage-secondPara-div">
                                <span className='emailText_2para'>{Labels[langCode].PARA_26} {emailHash}.  {isFMO ? Labels[langCode].PARA_27_FMO : Labels[langCode].PARA_27}</span>
                            </div>  
                        </Col>
                    </Row>
                    </Container>
                   
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                            <Container fluid className="buttons-container">
                                    <div className="div-btn-email">
                                    <Col xl={6} lg={6} md={6} sm={6} xs={12} xxs={12}  className="col-btn-email-update">
                                        <div className="update-btn">
                                            <Button  type="button" className="btn-email" data-disabled="false" onClick={handlePopulateEmailUpdateInput}>{Labels[langCode].UPDATE_EMAIL}</Button>
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={6} sm={6} xs={12} xxs={12}  className="col-btn-email-update">
                                        <div className="remove-btn">
                                            <Button  type="button" className="btn-email" data-disabled="false" onClick={handleEmailDelete}>{Labels[langCode].REMOVE_EMAIL}</Button>
                                        </div>
                                    </Col>
                                    </div>
                            </Container>
                        </Col>
               {
                    emailModalState ? <EmailModal 
                    emailId={newEmailId} 
                    callback={handleClose} 
                    modalUpdateState={emailUpdateTextState} 
                    modalDeleteState={emailDeleteTextState} 
                    langProp={langCode}
                    callbackUpdateEmail={handleUpdateEmail} 
                    callbackDeleteEmail={handleDeleteEmail} 
                    /> : ""
                }
                { update ?
                    <Container fluid className="update-container">
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-update">
                            <div className='div-update'>
                            <div className='div-inputedLabel-emailPage'>
                                <Form.Label className="form-label-email">{Labels[langCode].NEW_EMAIL}</Form.Label>
                              </div>
                                <div className='div-inputedEmail-emailPage'>
                                <Form.Control type="text" className="inputedEmail" defaultValue={newEmailId ? newEmailId : requestorEmailId} onChange={handleChangeEmail} />
                                </div>
                                {
                                        emailValidateErr ? <ValidationUI label={emailValidateErr} /> : ""
                                    }
                        <Container fluid>
                            <Row>
                            <Col xl={10} lg={10} md={10} sm={12} xs={12} xxs={12} className="col-buttons-emailupdatedBox">
                                <Container fluid className="buttons-container">
                                    <div className='div-btn-updateEmail-box'>
                                        <Col xl={5} lg={5} md={5} sm={6} xs={6} xxs={6}  className="col-buttons-emailupdatedBox-save">
                                            <div className="save-btn-updateEmail-box">
                                                <Button  type="button" className="btn-save" data-disabled="false" onClick={handleEmailUpdate}>{Labels[langCode].SAVE}</Button>
                                            </div>
                                        </Col>
                                        <Col xl={5} lg={5} md={5} sm={6} xs={6} xxs={6}   className="col-buttons-emailupdatedBox-cancel">
                                            <div className="cancel-btn-updateEmail-box">
                                                <Button  type="button" className="btn-cancel" data-disabled="false"  onClick={handleCancelEmailUpdateInput}>{Labels[langCode].CANCEL}</Button>
                                            </div>
                                        </Col>
                                        </div>
                                </Container>
                                </Col>
                                </Row>
                                </Container>
                                </div>
                                </Col>
                            </Row>
                    </Container>
                : ""}
                 {
        emailInfoModalState ? <EmailInfoModal updateModal={infoModalType} langProp={langCode} callbackClose={handleInfoClose}/> : ""
      } 
                <Container fluid className="container-text-second">
                    <Row className="row">
                        <Col lg={12} md={12} sm={12} xs={12} xxs={12}>
                        <span className='emailText_2para'>
                        {isFMO ? Labels[langCode].PARA_28_FMO : Labels[langCode].PARA_28}
                        </span>
                            <ButtonMailto style={{fontSize : '16px'}} label="privacy@b-rail.be" mailto="mailto:privacy@b-rail.be" />.
                        </Col>
                    </Row>   
                </Container>
                <Container fluid className="container-text-third">
                    <Row className="row">
                        <Col lg={12} md={12} sm={12} xs={12} xxs={12}>
                        
                        { langCode === "EN" ? 
                        <>
                        <span className='emailText_2para'>{Labels[langCode].PARA_29_EN}</span>
                        <a role="button" href="#" onClick={handlePolicyModal} className='text-policy'> {Labels[langCode].PARA_29_PRIVACY_POLICY_EN}.</a>
                        </> : ""
                        }
                        { langCode === "FR" ? 
                        <>
                        <span className='emailText_2para'>{Labels[langCode].PARA_29_FR}</span>
                        <a role="button" href="#" onClick={handlePolicyModal} className='text-policy'> {Labels[langCode].PARA_29_PRIVACY_POLICY_FR}.</a>
                        </> : ""
                        }
                        { langCode === "NL" ? 
                        <>
                        <span className='emailText_2para'>{Labels[langCode].PARA_29_NL}</span>
                        <a role="button" href="#" onClick={handlePolicyModal} className='text-policy'> {Labels[langCode].PARA_29_PRIVACY_POLICY_NL}.</a>
                        </> : ""
                        }
                        { langCode === "DE" ? 
                        <>
                        <span className='emailText_2para'>{Labels[langCode].PARA_29_DE}</span>
                        <a role="button" href="#" onClick={handlePolicyModal} className='text-policy'> {Labels[langCode].PARA_29_PRIVACY_POLICY_DE}</a>
                        </> : ""
                        }

                        {
                            policyModalState ? <PolicyModal callbackClose={handlePolicyClose} langCode={langCode}/> : ""
                        }
                        </Col>
                    </Row>
                </Container>
            </Col>
            <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
                <div>
                </div>
            </Col>
            </Row>
        </Container>: (presentEmailInvalidModal && !isEmailValid ? <EmailWarningModal langProp={langCode} callback={handleEmailNotVailableClose}/> : <div/>)}
        <Footer />
        </>
);
}

EmailComponent.propTypes = {
    hashCode: PropTypes.string,
    isFMO: PropTypes.bool,
};

export default EmailComponent;

